/**
 * The URLs of the staff team configuration area. Kept apart from
 * sections.ts, which imports every section page, so a link into the area
 * (the Employees page, the Add benchmark dialog) does not load them all.
 */

/** The staff area: the team list, with per-team configuration under teams/:teamId. */
export const EMPLOYEES_ROOT = '/employees'

/** The configuration area for a team, or one page of it. */
export function teamConfigPath(teamId: string, path?: string): string {
  const root = `${EMPLOYEES_ROOT}/teams/${teamId}`
  return path === undefined ? root : `${root}/${path}`
}
